import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PageContentBuilderService {

  constructor() { }

  buildPageContents(contents: any[], context: any): any[] {

    const handlers: Record<string, (ctx: any, content?: any) => any> = {
      'header-with-menu': ctx => ({ options: ctx.setHeaderData(), class: 'section-header-with-menu' }),
      'upsell-header': ctx => ({ options: ctx.setHeaderData(), class: 'section-upsell-header' }),
      'upsell-steps': (ctx, content) => ({ 
        options: { 
          ...ctx.setStepsData(), 
          ...(content?.options || {}) 
        } 
      }),
      'upsell-wait': ctx => ({ options: ctx.setWaitData() }),
      'upsell-section-1': ctx => ({ options: ctx.section_01_content, componentName: 'upsell-section' }),
      'upsell-section-2': ctx => ({ options: ctx.section_02_content, componentName: 'upsell-section' }),
      'upsell-section-3': ctx => ({ options: ctx.section_03_content, componentName: 'upsell-section' }),
      'upsell-product-box': ctx => ({ options: ctx.setProductBoxData() }),
      'upsell-guarantee': ctx => ({ options: ctx.setGarantee01Data() }),
      'upsell-product-box-full': ctx => ({ options: ctx.setProductBoxFullData() }),
      'upsell-wait-rectangular': ctx => ({ options: ctx.setWaitData() }),
      'progress-bar': ctx => ({ options: ctx.setProgressBarData() }),
      'upsell-sticky-bar': ctx => ({ options: ctx.setStickyBarData() }),
      'upsell-sticky-bar-v2': ctx => ({ options: ctx.setStickyBarV2Data() }),
      'video-player': ctx => ({ options: ctx.setVideoPlayerData(), componentName: 'video-player' }),
      'brand-reviews': ctx => ({ options: ctx.setBrandReview(), componentName: 'brand-reviews' }),      'upsell-offer-spinner': ctx => ({ options: ctx.setUpsellOfferSpinnerData(), componentName: 'upsell-offer-spinner' }),
      'upsell-modal': (ctx: any, content?: any) => ({ 
        options: ctx.setModalData ? ctx.setModalData(content?.options) : { 
          title: 'WAIT! Deeply discounted add-ons available!', 
          message: 'Enjoy fantastic benefits like:<ul><li>Smoother Digestion</li><li>easier weight management</li><li>More energy</li></ul>To thank you for your business, we\'re offering you <b>DEEP DISCOUNTS</b> on formulas to help accelerate your results. You may not ever see discounts this low again — act now to secure your savings.', 
          buttonText: 'CLAIM YOUR DISCOUNTS',
          html: ''
        } 
      }),
      'upsell-disclaimer': ctx => ({ options: ctx.setDisclaimerData() }),
      'upsell-footer': (ctx: any, content?: any) => ({ 
        options: {
          links: ctx.footerLinks || [],
          text: ctx.footerText || '',
          address: ctx.footerAddress || '',
          brand: ctx.productBrand || ''
        }
      }),
      'upsell-video': (_, content) => ({
        options: {
          ...(content?.options || {})
        }
      })
    };
     
    return contents.map((content, index) => {
      if (content.type === 'component') {
        const handler = handlers[content.componentName];
        if (handler) {
          const result = handler(context, content); 
          return {
            name: `content${index}`,
            type: 'component',
            componentName: result.componentName || content.componentName,
            options: result.options,
            class: result.class || content.class,
          };
        }
      } else if (content.type === 'html') {
        return { name: content.name, type: 'html', html: content.html };
      }
      return null;
    }).filter(Boolean);
  }
}
